
<template>
    <i-form ref="formLogin" :model="formLogin" :rules="formLoginRules"  class="card-box">
    <Form-item class="formLogin-title">
        <h3>系统登录</h3>
    </Form-item>
    <Form-item>
   <RadioGroup v-model="loginType" type="button" @on-change='choseloginType'>
        <Radio label="正式"></Radio>
        <Radio label="测试"></Radio>
    </RadioGroup>   
    </Form-item>
        <Form-item prop="username">
            <i-input size="large" type="text" v-model="formLogin.username"  placeholder="用户名">
                <!-- <Icon type="ios-person-outline" slot="prepend"></Icon> -->
            </i-input>
        </Form-item>
        <Form-item prop="password">
            <i-input size="large"  type="password" v-model="formLogin.password"   placeholder="密码">
                <!-- <Icon type="ios-locked-outline" slot="prepend"></Icon> -->
            </i-input>
        </Form-item>
        <Form-item>
            <i-input size="large"  type="text" v-model="formLogin.code"  @keyup.enter.native="handleSubmit('formLogin')" placeholder="验证码">
                <!-- <Icon type="ios-locked-outline" slot="prepend"></Icon> --> 
            </i-input>
            
        </Form-item>

        <Form-item>
            <span style="display:block">输入图中字符，不区分大小写</span>
             <img :src="codeImg" @click="getcode" class="codeimg" title="找不到图片">
             <span @click="getcode" class="newcode">
                 看不清，换一张
             </span>
        </Form-item>
          <Form-item class="login-no-bottom">
            <Checkbox-group v-model="formLogin.remember">
                <Checkbox label="记住密码" name="remember"></Checkbox>
            </Checkbox-group>
        </Form-item>

        <Form-item class="login-no-bottom">
            <Row >
                <i-col :xs="{ span: 4, offset: 6 }" >
                    <i-button type="primary" @click="handleSubmit('formLogin')">登录</i-button>
                </i-col>
                <i-col :xs="{ span: 4, offset: 6 }">
                    <i-button  type="primary" @click="formLoginReset('formLogin')">重置</i-button>
                </i-col>
            </Row>
        </Form-item>
    </i-form>
</template>
<script>
import md5 from "js-md5";
import { getcode, requestLogin, menulist, privilegescheck } from "../api/api";
import addRoutes from "../constant/addroutes.js";

import menudata from "../leftMenu.js";
export default {
  data() {
    return {
      formLogin: {
        username: "",
        password: "",
        code: "",
        remember: []
      },
      loginType: "正式",
      codeImg: "",
      formLoginRules: {
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
        getcode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        sessionStorage.setItem("user", JSON.stringify(this.formLogin.username));
        if (valid) {
          this.requestLogin();
        } else {
          this.$Message.error("表单验证失败!");
        }
        if (this.formLogin.remember[0] == "记住密码") {
          sessionStorage.setItem(
            "username",
            JSON.stringify(this.formLogin.username)
          );
          sessionStorage.setItem(
            "password",
            JSON.stringify(this.formLogin.password)
          );
        } else {
          sessionStorage.removeItem("username");
          sessionStorage.removeItem("password");
        }
      });
    },
    choseloginType() {
      sessionStorage.setItem("loginType", JSON.stringify(this.loginType));
      this.getcode();
    },
    requestLogin() {
      var _this = this;
      var data = {
        username: this.formLogin.username,
        password: this.formLogin.password,
        code: this.formLogin.code
      };
      requestLogin(data).then(res => {
        var data = res.data;

        if (data.code == 1) {
          _this.getmenulist(); //获取菜单
        } else {
          _this.$Message.error(data.message);
        }
      });
    },
    getmenulist() {
      var _this = this;
      let para = {};
      menulist(para).then(res => {
        var data = res.data;
        if (data.code == 1) {
          let menudata = data.data;
          var firstmenu = {};
          outerloop: for (let index = 0; index < menudata.length; index++) {
            if (menudata[index].link) {
              firstmenu = menudata[index];
              break outerloop;
            }
            if (menudata[index].submenu && menudata[index].submenu.length > 0) {
              let submenu = menudata[index].submenu;
              innerloop: for (let i = 0; i < submenu.length; i++) {
                const element = submenu[i];
                if (element.link) {
                  firstmenu = element;
                  break outerloop;
                }
                if (element.submenu && element.submenu.length > 0) {
                  let minsubmenu = element.submenu;
                  minloop: for (let a = 0; a < minsubmenu.length; a++) {
                    const item = minsubmenu[a];
                    if (item.link) {
                      firstmenu = item;
                      break outerloop;
                    }
                  }
                }
              }
            }
          }
          var data = {
            menudata: menudata
          };
          this.$store.commit("SIGN_Login", data);
          if (firstmenu) {
            _this.privilegescheck(firstmenu);
          }
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    privilegescheck(check) {
      privilegescheck({ id: check.id }).then(res => {
        var data = res.data;
        if (data.code == 1) {
          var Data = data.data;
          var data = {
            privilegescheck: Data
          };

          this.$store.commit("SIGN_Login", data);
          this.$router.push({ path: check.link });
        }
      });
    },
    getcode() {
      let timestamp = new Date().getTime();

      if (this.loginType == "正式") {
        this.codeImg =
          "https://www.migee.net/index.php/platform/index/code?device=PC" +
          "&timestamp=" +
          timestamp;
      } else if (this.loginType == "测试") {
        this.codeImg =
          "https://test.migee.net/index.php/platform/index/code?device=PC" +
          "&timestamp=" +
          timestamp;
      }

      this.timestamp = timestamp; //
    },
    formLoginReset(name) {
      this.$refs[name].resetFields();
    }
  },
  mounted() {
    this.getcode();
    this.getmenulist();
    if (sessionStorage.getItem("loginType")) {
      this.loginType = JSON.parse(sessionStorage.getItem("loginType"));
    }else{
      this.loginType="正式";
         sessionStorage.setItem("loginType", JSON.stringify(this.loginType));
    }
    if (sessionStorage.getItem("username")) {
      this.formLogin.username = JSON.parse(sessionStorage.getItem("username"));
    }
    if (sessionStorage.getItem("password")) {
      this.formLogin.password = JSON.parse(sessionStorage.getItem("password"));
    }
  }
};
</script>


<style scoped>
.card-box {
  padding: 20px;
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin-bottom: 20px;
  background-color: #f9fafc;
  margin: 180px auto;
  width: 400px;
  /* border: 2px solid #8492A6;*/
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.formLogin-title {
  text-align: center;
  font-size: 28px;
}
.formLogin-title h3 {
  font-size: 18px;
}
.login-no-bottom {
  margin-bottom: 10px;
}
.codeimg {
  max-width: 200px;
  vertical-align: bottom;
}
.newcode {
  text-decoration: underline;
  color: #2d8cf0;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue